module.exports = __webpack_public_path__ + "img/viegli.2c6bf8ab.png";